import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, catchError, of, throwError, timeout } from 'rxjs';
import { forkJoin } from 'rxjs';
import { GlobalVariablesService } from './global-variables.service';
import { ApplicationSettings } from '@app/shared/system/application-settings';
import { SettingsService } from './settings/settings.service';
import { ServiceName, ServiceReadyStateService } from './service-ready-state.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private readyBehavior = new BehaviorSubject<boolean>(false);
  public ready$ = this.readyBehavior.asObservable();


  constructor(
    private http: HttpClient,
    private globals: GlobalVariablesService,
    private settingService: SettingsService,
    private readyStateService: ServiceReadyStateService
  ) { }

  async loadConfig() {
    try {
      const applicationSettings = this.http.get<ApplicationSettings>(`${this.globals.apiV2Address}/client-services/get-application`).toPromise();

      const menuConfigurations = this.http.get<any>(`${this.globals.apiV2Address}/client-services/get-system-menu`).toPromise();

      const result = await forkJoin({ applicationSettings, menuConfigurations }).toPromise();

      this.globals.app = result.applicationSettings;
      this.globals.app.tenantId = 'acibadem'; // Geçici çözüm
      this.globals.navizardSystemMenu = result.menuConfigurations;


      await this.waitForSettingsReady();

      this.readyBehavior.next(true);
      this.readyStateService.setServiceReady(ServiceName.Config, true);

    } catch {
      this.readyBehavior.next(false);
      this.readyStateService.setServiceReady(ServiceName.Config, false);
    }
  }

  public async waitForSettingsReady() {
    this.settingService.refresh();
    const ready = await this.settingService.isReady.toPromise();

    if (!ready) return;

    // Mevcut protokol ve domaini al
    const currentProtocol = window.location.protocol; // 'http:' veya 'https:'
    const currentDomain = window.location.hostname;  // 'app.navizard.com'

    // Fotoğraf sunucusu adresini al ve kontrol et
    const photoServerAddress = this.settingService.getSettingValue<string>('General.Photo.Server.Address');
    this.globals.photoServerAddress = photoServerAddress && photoServerAddress.trim()
      ? photoServerAddress
      : `${currentProtocol}//image.${currentDomain}`;

    this.globals.photoServerApiAddress = `${this.globals.photoServerAddress}/api/v2`;

    // Tracker sunucusu adresini al ve kontrol et
    const trackerAddress = this.settingService.getSettingValue<string>('General.Tracker.SignalR.Address');
    this.globals.tracker.address = trackerAddress && trackerAddress.trim()
      ? trackerAddress
      : `${currentProtocol}//tracker.${currentDomain}`;

    try {
      const applicationSettings = await this.http.get<ApplicationSettings>(`${this.globals.tracker.address}/client-services/get-application`, {
        withCredentials: true
      })
        .pipe(
          timeout(3000),
          catchError(this.handleError)
        )
        .toPromise();

      if (applicationSettings) {
        this.globals.tracker.version = applicationSettings.version;
        // Versiyonla ilgili işlemleri burada yapabilirsiniz
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  }

  private handleError(error: HttpErrorResponse) {
    return throwError(() => new Error(`An error occurred: ${error.message}`));
  }

}


